import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminFrequently_asked_questions = z.any()
export type TagsGetAdminFrequently_asked_questions = z.infer<typeof tagsGetAdminFrequently_asked_questions>

export const querystringGetAdminFrequently_asked_questions = z.object({ "page": z.string().optional(), "perPage": z.string().optional(), "text": z.string().optional(), "filter": z.union([z.literal("ALL"), z.literal("PUBLIC"), z.literal("HIDDEN")]).optional(), "order": z.union([z.literal("asc"), z.literal("desc")]).optional() })
export type QuerystringGetAdminFrequently_asked_questions = z.infer<typeof querystringGetAdminFrequently_asked_questions>

export const responseGetAdminFrequently_asked_questions = z.object({ "payload": z.array(z.object({ "id": z.string(), "question": z.string(), "answer": z.string(), "visibility": z.union([z.literal("PUBLIC"), z.literal("HIDDEN")]), "userId": z.string(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminFrequently_asked_questions = z.infer<typeof responseGetAdminFrequently_asked_questions>

interface IGetAdminFrequently_asked_questions extends BaseMethodType {
  tags: TagsGetAdminFrequently_asked_questions,
  querystring: QuerystringGetAdminFrequently_asked_questions,
  response: ResponseGetAdminFrequently_asked_questions
}
export const tagsPostAdminFrequently_asked_questions = z.any()
export type TagsPostAdminFrequently_asked_questions = z.infer<typeof tagsPostAdminFrequently_asked_questions>

export const bodyPostAdminFrequently_asked_questions = z.object({ "question": z.string().min(1).max(500), "answer": z.string().min(1).max(2000), "visibility": z.union([z.literal("PUBLIC"), z.literal("HIDDEN")]) })
export type BodyPostAdminFrequently_asked_questions = z.infer<typeof bodyPostAdminFrequently_asked_questions>

export const responsePostAdminFrequently_asked_questions = z.object({ "payload": z.object({ "id": z.string(), "question": z.string(), "answer": z.string(), "visibility": z.union([z.literal("PUBLIC"), z.literal("HIDDEN")]), "userId": z.string(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminFrequently_asked_questions = z.infer<typeof responsePostAdminFrequently_asked_questions>

interface IPostAdminFrequently_asked_questions extends BaseMethodType {
  tags: TagsPostAdminFrequently_asked_questions,
  body: BodyPostAdminFrequently_asked_questions,
  response: ResponsePostAdminFrequently_asked_questions
}
export const URL = '/admin/frequently-asked-questions'
export const validation = {
  get: {
    tags: tagsGetAdminFrequently_asked_questions,
    querystring: querystringGetAdminFrequently_asked_questions,
    response: responseGetAdminFrequently_asked_questions
  },
  post: {
    tags: tagsPostAdminFrequently_asked_questions,
    body: bodyPostAdminFrequently_asked_questions,
    response: responsePostAdminFrequently_asked_questions
  }
}
export interface AdminFrequently_asked_questions extends BaseRouteType {
  get: IGetAdminFrequently_asked_questions,
  post: IPostAdminFrequently_asked_questions
}